import {
  Box,
  Grid,
  Flex,
  Avatar,
  Text,
  useColorModeValue,
  Icon,
} from '@chakra-ui/react';
import React from 'react';
import { FiPhone, FiMapPin, FiFlag, FiGlobe } from 'react-icons/fi'; 

// Assets
import avatar from 'assets/img/avatars/USER_LOGO.webp';

export default function Overview() {
  const user = JSON.parse(localStorage.getItem('user'));
  console.log("User Data:", user);

  const cardBg = useColorModeValue('white', 'gray.700');
  const cardTextColor = useColorModeValue('gray.700', 'white');
  const bannerBg = useColorModeValue(
    'linear-gradient(135deg, #90cdf4, #63b3ed, #3182ce)',
    'linear-gradient(135deg, #2c5282, #2a4365, #1a365d)',
  );

  const additionalFields = [];

  if (user.role === 'tahsildar') {
    additionalFields.push(
      { label: 'Divisional', value: user.division.name, icon: FiGlobe },
      { label: 'District', value: user.district.name, icon: FiMapPin },
      { label: 'Tahsil', value: user.tahsil.name, icon: FiFlag }
    );
  } else if (user.role === 'collector') {
    additionalFields.push(
      { label: 'Division', value: user.division.name, icon: FiGlobe },
      { label: 'District', value: user.district.name, icon: FiMapPin }
    );
  } else if (user.role === 'division') {
    additionalFields.push(
      { label: 'Divisional', value: user.division.name, icon: FiGlobe }
    );
  }

  return (
    <Box
      pt={{ base: '140px', md: '90px', xl: '90px', sm: '100px' }}
      px={{ base: '4', md: '8' }}
    >
      {/* Profile Banner */}
      <Flex
        direction="column"
        align="center"
        bg={bannerBg}
        borderRadius="lg"
        p={{ base: 6, md: 8 }}
        mb={6}
        boxShadow="lg"
        position="relative"
      >
        <Avatar
          size="2xl"
          src={avatar}
          alt="User Avatar"
          mb={4}
          boxShadow="lg"
          borderWidth={3}
          borderColor={cardBg}
        />
        <Text fontSize="2xl" fontWeight="bold" color={cardTextColor}>
          {user.name.toUpperCase()}
        </Text>
        <Text fontSize="lg" color="gray.800" mb={4}>
          {user.role.toUpperCase()}
        </Text>
      </Flex>

      {/* Information Cards */}
      <Grid
        templateColumns={{
          base: '1fr',
          md: 'repeat(2, 1fr)',
          lg: 'repeat(3, 1fr)',
        }}
        gap={6}
      >
        {/* Phone */}
        <InfoCard
          icon={FiPhone}
          label="Phone Number"
          value={user.phoneNo}
          cardBg={cardBg}
          cardTextColor={cardTextColor}
        />

        {/* Additional fields based on role */}
        {additionalFields.map((field, idx) => (
          <InfoCard
            key={idx}
            icon={field.icon}
            label={field.label}
            value={field.value.toUpperCase()}
            cardBg={cardBg}
            cardTextColor={cardTextColor}
          />
        ))}
      </Grid>
    </Box>
  );
}

const InfoCard = ({ icon, label, value, cardBg, cardTextColor }) => (
  <Box
    bg={cardBg}
    p={4}
    borderRadius="lg"
    boxShadow="sm"
    transition="transform 0.3s ease"
    _hover={{ transform: 'scale(1.03)' }}
  >
    <Text fontWeight="bold" color={cardTextColor} mb={1}>
      {label}
    </Text>
    <Flex align="center" gap={2}>
      <Icon as={icon} boxSize={4} color="blue.400" />
      <Text fontSize="sm" color="gray.500">
        {value || 'N/A'}
      </Text>
    </Flex>
  </Box>
);

